import { __assign } from "tslib";
export var AI_TAG = 'AI';
var FIELD_OF_RISK = 'riskLevel';
export var isAIItem = function (item) {
    return (item === null || item === void 0 ? void 0 : item.riskTag) === AI_TAG;
};
export var isPassItem = function (item) {
    return (item === null || item === void 0 ? void 0 : item.riskLevel) === 'PASS';
};
export var isErrorItem = function (item) {
    return (item === null || item === void 0 ? void 0 : item.riskLevel) === 'ERROR' || (item === null || item === void 0 ? void 0 : item.isOutOfLimitReject);
};
export var isWarningItem = function (item) {
    return (item === null || item === void 0 ? void 0 : item.riskLevel) === 'WARNING';
};
export var getAIAuditSummary = function (riskData) {
    if (riskData === void 0) { riskData = []; }
    var AIData = riskData.filter(isAIItem);
    var total = AIData.length;
    var successCount = AIData.filter(isPassItem).length;
    var riskCount = AIData.filter(isWarningItem).length;
    var errorCount = AIData.filter(isErrorItem).length;
    return {
        total: total,
        successCount: successCount,
        riskCount: riskCount,
        errorCount: errorCount
    };
};
export var getRiskItems = function (riskData) {
    if (riskData === void 0) { riskData = []; }
    if (riskData.length === 0)
        return [];
    return riskData.filter(function (item) {
        if (item.hasOwnProperty(FIELD_OF_RISK)) {
            return isErrorItem(item) || isWarningItem(item);
        }
        return true;
    });
};
export var polyfillForAIRiskData = function (_riskData) {
    var _a;
    if (_riskData === void 0) { _riskData = {}; }
    var riskItems = getRiskItems(_riskData.riskWarningV2);
    var valueRiskWarning = getRiskItems(((_a = _riskData.value) === null || _a === void 0 ? void 0 : _a.riskWarning) || []);
    return __assign(__assign({}, _riskData), { riskWarningV2: riskItems, value: __assign(__assign({}, _riskData.value), { riskWarning: valueRiskWarning }) });
};
